"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
tslib_1.__exportStar(require("../../_util/use-outside-click"), exports);
//# sourceMappingURL=useOutsideClick.js.map